import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import CloseIcon from '../../assets/CloseIcon'
import EditIcon from '../../assets/EditIcon'
import {
  PAGE_CONST,
  PERMISSION_TYPE,
  PROFILE_CONST,
  SETTINGS_NAVIGATION_ITEMS,
  SETTINGS_CONST,
  PERMISSION_FEATURE,
} from '../../common/constant/page-constant'
import Header from '../Common/Header/Header'

import SideMenu from '../Common/SideMenu/SideMenu'

import { activeSettingsDetailNavigation } from '../../modules/actions/action'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import MobileHeader from '../Common/Header/MobileHeader'
import { SIDEBAR_CONST } from '../../common/constant/common-constant'

import './Settings.scss'
import { navigate } from '../../common/utils/redirectionUtils'
import PharmacyStore from '../PharmacyStore/PharmacyStore'
import ManageCustomer from '../ManageCustomer/ManageCustomer'
import ManageUser from '../ManageUser/ManageUser'
import ManageSupplier from '../ManageSupplier/ManageSupplier'
import ManageProduct from '../ManageProduct/ManageProduct'
import PharmacyRequest from '../PharmacyRequest/PharmacyRequest'
import CommissionEarnings from '../CommissionEarnings/CommissionEarnings'
import PlatformCharges from '../PlatformCharges/PlatformCharges'
import DeliveryManManagement from '../DeliveryManManagement/DeliveryManManagement'
import ConsumerOrders from '../ConsumerOrders/ConsumerOrders'
import ManagePharmacyInventory from '../ManagePharmacyInventory/ManagePharmacyInventory'

const Settings = (props) => {
  const isMobile = useCheckMobileScreen()

  const [viewDrawer, setViewDrawer] = useState(false)
  const [activeItem, setActiveItem] = useState(undefined)
  const [open, setOpen] = useState(false)
  const [permissions, setPermissions] = useState({})

  const headerOptions = {
    isBackVisible: false,
    title: 'User Profile',
  }

  const handleDrawerToggle = () => {
    setViewDrawer(!viewDrawer)
    setOpen(!open)
  }

  useEffect(() => {
    if (
      props.config?.activeSettingsDetailNavigation &&
      permissions?.features &&
      permissions?.features?.[props.config?.activeSettingsDetailNavigation] !==
        PERMISSION_TYPE.RESTRICTED
    ) {
      setActiveItem(props.config.activeSettingsDetailNavigation)
    }
  }, [props.config?.activeSettingsDetailNavigation, permissions])

  const handleItemClick = (itemName) => {
    props.dispatchActiveSettingsDetailNavigation(itemName)
  }

  const handleClose = () => {
    navigate(PAGE_CONST.HOME)
  }

  useEffect(() => {
    if (props.loginData.permissions) {
      let permission = props.loginData.permissions.reduce((acc, permission) => {
        acc.features = {
          ...acc.features,
          ...permission.features,
        }

        return acc
      }, {})

      if (permission) setPermissions(permission)
    }
  }, [props.loginData])

  const checkFeaturePermission = (item) => {
    if (item.feature === PERMISSION_FEATURE.COMMISSION_EARNINGS) {
      if (
        permissions?.features?.[
          PERMISSION_FEATURE.COMMISSION_EARNING_FROM_PHARMACY_STORE
        ] !== PERMISSION_TYPE.RESTRICTED ||
        permissions?.features?.[
          PERMISSION_FEATURE.COMMISSION_EARNING_FROM_SUPPLIER
        ] !== PERMISSION_TYPE.RESTRICTED
      )
        return true
    } else if (item.feature === PERMISSION_FEATURE.PLATFORM_CHARGE) {
      if (
        permissions?.features?.[
          PERMISSION_FEATURE.PLATFORM_CHARGE_FROM_CONSUMER
        ] !== PERMISSION_TYPE.RESTRICTED ||
        permissions?.features?.[
          PERMISSION_FEATURE.PLATFORM_CHARGE_FROM_PHARMACY_STORE
        ] !== PERMISSION_TYPE.RESTRICTED
      )
        return true
    } else if (item.feature === PERMISSION_FEATURE.PHARMACY_REQUESTS) {
      if (
        permissions?.features?.[PERMISSION_FEATURE.NEW_PRODUCT_REQUEST] !==
          PERMISSION_TYPE.RESTRICTED ||
        permissions?.features?.[PERMISSION_FEATURE.NEW_SUPPLIER_REQUEST] !==
          PERMISSION_TYPE.RESTRICTED
      )
        return true
    } else {
      if (
        permissions?.features?.[item.feature] !== PERMISSION_TYPE.RESTRICTED
      ) {
        return true
      }
    }

    return false
  }

  return (
    <div className="containerHome">
      {!isMobile && <Header />}
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      <SideMenu
        activeItem={SIDEBAR_CONST.SETTINGS}
        component={!activeItem && PAGE_CONST.SETTINGS}
      />
      <div className="pageBody dFlex">
        <div className="pageBodyLeftPanel sticky">
          {!isMobile && (
            <div className="chainNavigationWrapper">
              <ul className="chainNavigation">
                {SETTINGS_NAVIGATION_ITEMS.map((item) => {
                  if (checkFeaturePermission(item)) {
                    return (
                      <li
                        className={`chainItem ${
                          activeItem === item.feature ? 'active' : ''
                        }`}
                        onClick={() => handleItemClick(item.feature)}
                      >
                        {item.profileDetailIcon}
                        <span>{item.name}</span>
                      </li>
                    )
                  }
                })}
              </ul>
            </div>
          )}
        </div>
        {activeItem === PERMISSION_FEATURE.PHARMACY_STORE && <PharmacyStore />}
        {activeItem === PERMISSION_FEATURE.CONSUMER && <ManageCustomer />}
        {activeItem === PERMISSION_FEATURE.CONSUMER_ORDERS && <ConsumerOrders />}
        {activeItem === PERMISSION_FEATURE.SUPPLIER && <ManageSupplier />}
        {activeItem === PERMISSION_FEATURE.MANAGE_USERS && <ManageUser />}
        {activeItem === PERMISSION_FEATURE.MANAGE_PRODUCT && <ManageProduct />}
        {activeItem === PERMISSION_FEATURE.DELIVERY_MAN_MANAGEMENT && <DeliveryManManagement />}
        {activeItem === PERMISSION_FEATURE.COMMISSION_EARNINGS && (
          <CommissionEarnings />
        )}
        {activeItem === PERMISSION_FEATURE.PLATFORM_CHARGE && (
          <PlatformCharges />
        )}
        {activeItem === PERMISSION_FEATURE.PHARMACY_REQUESTS && (
          <PharmacyRequest />
        )}
        {activeItem === PERMISSION_FEATURE.PHARMACY_INVENTORY && (
          <ManagePharmacyInventory />
        )}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    config: state.configReducer.config,
    loginData: state.loginDataReducer?.loginData,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchActiveSettingsDetailNavigation: (payload) =>
      dispatch(activeSettingsDetailNavigation(payload)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
